import { Component, Inject, ViewChild, OnInit } from '@angular/core';

import { TableListGridProviderDirective } from '@app/components/table-list-grid/directives/table-list-grid-provider.directive';
import { GridMode } from '@app/components/table-list-grid/grid-mode';
import { AppConfig, appConfigService } from '@app/config';

import { ColumnTypeUtils } from '@app/shared/util/column-type-utils';
import { TableListGridUtil } from '@app/shared/util/table-list-grid-util';
import {
  AttributeStateService,
  CoreConfig,
  CoreConfigService,
  FilterView,
  FilterViewProviderDirective,
  Item,
  NtapGlobalConstants,
  Util
} from '@ntap/core';
import { ColumnInfo, TableData, TableMeta } from '@ntap/primeng';
import { Table } from 'primeng/table';
import { map, Observable } from 'rxjs';
import { EarhivUiComponents } from '..';
import {
  KEY_IS_OPENITEM,
  NtapListComponent
} from '../ntap-list/ntap-list.component';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-table-list-grid',
  templateUrl: './table-list-grid.component.html',
  styleUrls: ['./table-list-grid.component.scss']
})
export class TableListGridComponent
  extends NtapListComponent
  implements OnInit
{
  constructor(
    protected override listViewProvider: TableListGridProviderDirective,
    protected filterViewProvider: FilterViewProviderDirective<FilterView>,
    @Inject(CoreConfigService) protected override coreConfig: CoreConfig,
    @Inject(appConfigService) protected config: AppConfig,
    protected override attributeStateService: AttributeStateService
  ) {
    super(listViewProvider, coreConfig, attributeStateService);
    this.tableData$.subscribe((tableData) => console.log(tableData));
    this.selectedItems$.subscribe(
      (selectedIt) => (this.selectedItems = selectedIt)
    );
  }

  showFullText: boolean = false;

  // Pohrana referenci na OverlayPanel instance
  private overlayPanels: { [key: number]: OverlayPanel } = {};

  public layoutOptions: { label: string; value: GridMode }[] = [
    { label: 'Rešetka', value: 'grid' },
    { label: 'Lista', value: 'list' },
    { label: 'Tablica', value: 'table' }
  ];
  public selectedLayoutOption = this.layoutOptions[2];
  public defaultImage = 'https://placehold.co/600x400?text=Nema%20slike';
  public selectedItems: any[] = [];
  public actionBarCompId = EarhivUiComponents.EDIT_ACTIONBAR;
  public tableMetaWithConfig$: Observable<
    TableMeta & {
      titleColumn?: string;
      labelColumn?: string;
      labelNameColumn?: string;
      ownerColumn?: string;
      historyColumn?: string;
      levelColumn?: string;
      createdColumn?: string;
      superiorItemColumn?: string;
      contentColumn?: string;
      licenceColumn?: string;
      agentTypeColumn?: string;
      ownerTypeColumn?: string;
      statusColumn?: string;
      identifierColumn?: string;
      archiveOwnerColumn?: string;
      timespanColumn?: string;
      headquartersColumn?: string;
      hoursColumn?: string;
      webpageColumn?: string;
      quantityColumn?: string;
      contentTypeColumn?: string;
      hierarhyLabelColumn?: string;
    }
  >;

  @ViewChild('dataTable')
  dataTable: Table;

  override ngOnInit() {
    super.ngOnInit();
    this.tableMetaWithConfig$ = this.tableMetaWithDataKey$.pipe(
      map((e) => {
        const title = TableListGridUtil.getColumnByDataType(e, 'title');
        return {
          ...e,
          titleColumn: title,
          isTitleOpenItemColumn:
            title && this.isColumneOpenItemColumn(e, title),
          labelColumn: TableListGridUtil.getColumnByDataType(e, 'label'),
          labelNameColumn: TableListGridUtil.getColumnByDataType(
            e,
            'label-name'
          ),
          ownerColumn: TableListGridUtil.getColumnByDataType(e, 'owner'),
          historyColumn: TableListGridUtil.getColumnByDataType(e, 'history'),
          levelColumn: TableListGridUtil.getColumnByDataType(e, 'level'),
          createdColumn: TableListGridUtil.getColumnByDataType(e, 'created'),
          superiorItemColumn: TableListGridUtil.getColumnByDataType(
            e,
            'superior-item'
          ),
          contentColumn: TableListGridUtil.getColumnByDataType(e, 'content'),
          licenceColumn: TableListGridUtil.getColumnByDataType(e, 'licence'),
          agentTypeColumn: TableListGridUtil.getColumnByDataType(
            e,
            'agent-type'
          ),
          ownerTypeColumn: TableListGridUtil.getColumnByDataType(
            e,
            'owner-type'
          ),
          statusColumn: TableListGridUtil.getColumnByDataType(e, 'status'),
          identifierColumn: TableListGridUtil.getColumnByDataType(
            e,
            'identifier'
          ),
          archiveOwnerColumn: TableListGridUtil.getColumnByDataType(
            e,
            'archive-owner'
          ),
          timespanColumn: TableListGridUtil.getColumnByDataType(e, 'timespan'),
          headquartersColumn: TableListGridUtil.getColumnByDataType(
            e,
            'headquarters'
          ),
          hoursColumn: TableListGridUtil.getColumnByDataType(e, 'hours'),
          webpageColumn: TableListGridUtil.getColumnByDataType(e, 'webpage'),
          quantityColumn: TableListGridUtil.getColumnByDataType(e, 'quantity'),
          contentTypeColumn: TableListGridUtil.getColumnByDataType(
            e,
            'content-type'
          ),
          hierarhyLabelColumn: TableListGridUtil.getColumnByDataType(
            e,
            'hierarchy-label'
          )
        };
      })
    );
  }

  private isColumneOpenItemColumn(meta: any, name: string) {
    const column = meta.columns.find((c: ColumnInfo) => c.name === name);
    return column[KEY_IS_OPENITEM];
  }

  changeLayout(event: Event, layout: GridMode) {
    this.listViewProvider.changeLayoutView(layout);
    this.selectedLayoutOption = this.layoutOptions.find(
      (option) => option.value == layout
    )!;
    this.actionBarCompId = EarhivUiComponents.EDIT_ACTIONBAR;
    event.preventDefault();
  }

  errorImg(target: any) {
    target.src = this.defaultImage;
  }
  createUrl(item: any) {
    const itemType =
      item[NtapGlobalConstants.ATTR_$mainType] ||
      item[NtapGlobalConstants.ATTR_$itemType];
    const idAttr = Util.getFullAttrName(itemType, NtapGlobalConstants.ATTR_id);
    const id = item[idAttr];
    const url =
      this.config.ntapEnvironment?.pathApiNtap +
        `/content/readContent?objectType=${itemType}&objectId=${id}&renditionName=${this.getRenditionName()}` ||
      '';
    const imageUrl = item['$hasContent'] ? url : this.defaultImage;
    return imageUrl;
  }
  protected getRenditionName(): string {
    return 'default';
  }

  // isOpenItemColumn(colName: string, view: View) {
  //   return (
  //     colName.indexOf('naziv') >= 0 &&
  //     view.actions.filter((a: any) => a.name.indexOf('open') >= 0).length > 0
  //   );
  // }

  // openItem(event: Event, listItemProvider: ListItemProviderDirective) {
  //   event.preventDefault();
  //   for (const dynamicActionToolbar of this.dynamicActionToolbars) {
  //     if (dynamicActionToolbar) {
  //       const primengActionBar =
  //         dynamicActionToolbar.getViewComponent() as PrimeNGListActionBarComponent;
  //       const dynamicActionComp = primengActionBar.dynamicComponents.find(
  //         (c) =>
  //           (c.getViewComponent() as ActionComponent).action.name.indexOf(
  //             'open'
  //           ) >= 0
  //       );
  //       if (dynamicActionComp) {
  //         const actionComp = dynamicActionComp.getViewComponent() as any;
  //         if (actionComp.itemProvider === listItemProvider) {
  //           actionComp.execute();
  //           break;
  //         }
  //       }
  //     }
  //   }
  // }
  selectItem(item: any): void {
    const index = this.selectedItems.findIndex(
      (selectedItem) => selectedItem[this.dataKey] === item[this.dataKey]
    );
    if (index === -1) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems.splice(index, 1);
    }

    super.setSelectedItems(this.selectedItems);
  }

  isSelected(item: any): boolean {
    return this.selectedItems.some(
      (selectedItem) => selectedItem[this.dataKey] === item[this.dataKey]
    );
  }

  stringify(any: any) {
    return JSON.stringify(any);
  }

  isStatusColumn(columnName: string): boolean {
    return ColumnTypeUtils.isStatusColumn(columnName);
  }

  gridtoggleExpandedRow(tableData: TableData, item: Item) {
    this.selectItem(item);
    this.toggleExpandedRow(tableData, item);
  }

  shouldShowToggle(data: string): boolean {
    return data.length > 599;
  }

  // Prikaz overlay panela
  showOverlay(event: MouseEvent, op: OverlayPanel, rowIndex: number): void {
    this.overlayPanels[rowIndex] = op;
    op.show(event);
  }

  // Sakrivanje overlay panela
  hideOverlay(op: OverlayPanel, rowIndex: number): void {
    if (this.overlayPanels[rowIndex]) {
      this.overlayPanels[rowIndex].hide();
      delete this.overlayPanels[rowIndex];
    }
  }
}
